import { makeStyles } from '@material-ui/styles';

const MessageContentWrapper: React.FC = ({ children }) => {
    const classes = useStyles();

    return <div className={classes.messageContentWrapper}>{children}</div>;
};

const useStyles = makeStyles(
    () => ({
        messageContentWrapper: {
            display: 'flex',
            flexDirection: 'column',
            padding: '24px 24px 0 24px',
        },
    }),
    { classNamePrefix: 'chat-message-content-wrapper' }
);

export default MessageContentWrapper;
